import { defineStore } from "pinia";
import Api from "@/api";

export const useFranchiseeSelectorList = () => {
  const store = defineStore(`franchiseesList`, {
    persist: {
      storage: sessionStorage
    },
    state: () => ({
      franchisees: {},
      municipalities: {},
      updatedOn: 0,
      loadFailed: false,
    }),
    actions: {
      async fetchFranchisees(updatedOnState = -1) {
        if (Object.keys(this.franchisees).length && this.updatedOn === updatedOnState) {
          return;
        }

        try {
          const { data } = await Api.request(`franchisees-list`);

          this.setFranchisees(data?.franchisees ?? []);
          this.setMunicipalities(data?.municipalities ?? []);

          this.loadFailed = false;
          this.updatedOn = updatedOnState;
        } catch (error) {
          this.setFranchisees([]);
          this.setMunicipalities([]);

          this.loadFailed = true;
        }
      },
      setFranchisees(data) {
        this.franchisees = data;
      },
      setMunicipalities(data) {
        this.municipalities = data;
      },
    },
    getters: {},
  });

  return store();
};
